import { format } from "date-fns";
import pt from "date-fns/locale/pt";

function formatDate(date) {
  try {
    const dateObj = Date.parse(date);
    return format(dateObj, "dd LLL yyyy", {
      locale: pt
    });
  } catch (e) {
    return "";
  }
}

function formatDateWithHours(date) {
  try {
    const dateObj = Date.parse(date);
    return format(dateObj, "dd LLL yyyy HH:mm", {
      locale: pt
    });
  } catch (e) {
    return "";
  }
}

function formatDateDayMonthYear(date) {
  try {
    const dateObj = Date.parse(date);
    return format(dateObj, "dd/LL/yyyy", {
      locale: pt
    });
  } catch (e) {
    console.log(e);
    return "";
  }
}

function formatDateDayMonthYearHoursMinutes(date) {
  try {
    const dateObj = Date.parse(date);
    return format(dateObj, "yyyy-LL-dd HH:mm", {
      locale: pt
    });
  } catch (e) {
    console.log(e);
    return "";
  }
}

function alphabeticalSort(array, propertyToSort) {
  return array.sort(function(a, b) {
    if (a[propertyToSort] < b[propertyToSort]) {
      return -1;
    }
    if (a[propertyToSort] > b[propertyToSort]) {
      return 1;
    }
    return 0;
  });
}

/** Usa a translation para alterar a key do objecto ex. ID -> canvasserIdEntity e remove as keys que não existem na translation */
function keyMapper(item, translation) {

  Object.keys(item).forEach(key => {
    if(translation[key]) {
      const value = item[key];
      delete item[key];
      item[translation[key]] = value;
    } else { 
      delete item[key]
    }
  })

  return item;
}

export {
  formatDate,
  formatDateWithHours,
  formatDateDayMonthYear,
  formatDateDayMonthYearHoursMinutes,
  alphabeticalSort,
  keyMapper
};
